var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilterlarge = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "filter-a",
    d: "M1-.019H-23L-14.624,10.8V23.981l7.4-3.941V10.6ZM-13.161,21.528V10.517l-7.121-9.2H-1.717l-6.968,9v1.353H-11v1.483h2.315v1.24H-11v1.481h2.315v1.241H-11V18.6h2.315v.549Z",
    transform: "translate(23 0.019)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilterlarge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/filterlarge.7689219c946f78b4101ce2ad6551a238.svg";